import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { SellerAnalyticsModalDisplayType } from '../types';

type SellerAnalyticsModalProviderProps = {
  children: ReactNode;
};

type SellerAnalyticsModalContextValue = {
  isSellerAnalyticsModalOpen: boolean;
  setIsSellerAnalyticsModalOpen: (open: boolean) => void;
  sellerAnalyticsModalDisplay?: SellerAnalyticsModalDisplayType;
  setSellerAnalyticsModalDisplay: (
    display: SellerAnalyticsModalDisplayType | undefined,
  ) => void;
};

const SellerAnalyticsModalContext =
  createContext<SellerAnalyticsModalContextValue>({
    isSellerAnalyticsModalOpen: false,
    setIsSellerAnalyticsModalOpen: () => null,
    sellerAnalyticsModalDisplay: undefined,
    setSellerAnalyticsModalDisplay: () => null,
  });

const SellerAnalyticsModalProvider = ({
  children,
}: SellerAnalyticsModalProviderProps) => {
  const [isSellerAnalyticsModalOpen, setIsSellerAnalyticsModalOpen] =
    useState<boolean>(false);
  const [sellerAnalyticsModalDisplay, setSellerAnalyticsModalDisplay] =
    useState<SellerAnalyticsModalDisplayType | undefined>(undefined);

  const value = useMemo(
    () => ({
      isSellerAnalyticsModalOpen,
      setIsSellerAnalyticsModalOpen,
      sellerAnalyticsModalDisplay,
      setSellerAnalyticsModalDisplay,
    }),
    [isSellerAnalyticsModalOpen, sellerAnalyticsModalDisplay],
  );

  return (
    <SellerAnalyticsModalContext.Provider value={value}>
      {children}
    </SellerAnalyticsModalContext.Provider>
  );
};

const useSellerAnalyticsModal = () => useContext(SellerAnalyticsModalContext);

export { SellerAnalyticsModalProvider, useSellerAnalyticsModal };
